module.exports = __webpack_public_path__ + "static/media/user.3de5aefd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/user.svg
// module id = 35
// module chunks = 1